/**
 * Generated by orval v6.27.1 🍺
 * Do not edit manually.
 * Workspace Warden
 * OpenAPI spec version: 0.0.1
 */

export type ProductDetailsDtoKind =
  (typeof ProductDetailsDtoKind)[keyof typeof ProductDetailsDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductDetailsDtoKind = {
  DRIVE: 'DRIVE',
  CALENDAR: 'CALENDAR',
  MAILBOX: 'MAILBOX',
} as const;
